import { useContext } from "react";
import { useDispatch, useSelector } from "react-redux";

import { EditorContext } from "../containers/editor/EditorLayout";
import { setUsedProposalModule } from "../store/actions/companyActions";

const useProposalInUseModule = () => {
  const { widgets } = useContext(EditorContext);
  const dispatch = useDispatch();

  const companyId = useSelector(state => state.auth?.user?.company?.id);
  const { id: documentId } = useSelector(state => state.document?.documentDetails?.data) ?? {
    id: null,
  };

  const filterSections = sectionArray => {
    const uniqueIds = [];
    // Loop through each section
    sectionArray.forEach(section => {
      // Switch case to check section.slug
      switch (section.slug) {
        case "flight":
          if (section?.airline?.id && !uniqueIds.includes(section?.airline?.id)) {
            uniqueIds.push(section.airline.id);
          }
          break;

        case "accommodation":
          if (section?.property_name?.id && !uniqueIds.includes(section?.property_name?.id)) {
            uniqueIds.push(section.property_name.id);
          }
          break;

        case "meal":
          if (section?.restaurant_name?.id && !uniqueIds.includes(section?.restaurant_name?.id)) {
            uniqueIds.push(section.restaurant_name.id);
          }
          break;

        case "car_rental":
          if (section?.real_agency_name?.id && !uniqueIds.includes(section?.real_agency_name?.id)) {
            uniqueIds.push(section.real_agency_name.id);
          }
          break;

        case "cruise":
          if (section?.cruise_line?.id && !uniqueIds.includes(section?.cruise_line?.id)) {
            uniqueIds.push(section.cruise_line.id);
          }
          break;

        case "activity":
          if (section?.provider_name?.id && !uniqueIds.includes(section?.provider_name?.id)) {
            uniqueIds.push(section.provider_name.id);
          }
          break;

        case "transfer":
          if (section?.provider_name?.id && !uniqueIds.includes(section?.provider_name?.id)) {
            uniqueIds.push(section.provider_name.id);
          }
          break;

        default:
          break;
      }
    });

    return uniqueIds;
  };

  const itineraryInUseFn = (itemList, extraIds) => {
    let uniqueArrayIds = filterSections(itemList);
    if (extraIds.length > 0) {
      uniqueArrayIds = [...new Set([...uniqueArrayIds, ...extraIds])];
    }
    let inUseProposalModuleList = {
      travel_suppliers: uniqueArrayIds,
    };

    dispatch(setUsedProposalModule(companyId, { document_id: documentId }, inUseProposalModuleList));
  };

  const triggerInUse = (moduleName, activeWidgetIds = [], extraIds = []) => {
    let recordList = [];
    widgets.forEach(item => {
      if (item.data["data-widget"] === moduleName && !activeWidgetIds.includes(item.id)) {
        let tableConfig = item.data["data-table-config"];
        tableConfig = JSON.parse(tableConfig);
        let itemList = tableConfig.items;
        recordList = [...recordList, ...itemList];
      }
    });

    if (moduleName === "ITINERARY") {
      itineraryInUseFn(recordList, extraIds);
    }
  };

  return triggerInUse;
};

export default useProposalInUseModule;
